isClientField